import { useQuery } from "@tanstack/react-query";

import { getProject } from "@/api/projectsApi";
import { projectsKeys } from "@/api/projectsKeys";
import { apiErrorMeta } from "@/lib/apiErrorHandling";
import type { ProjectDto } from "@/types/api/projects";

export function useProject(id: string | undefined) {
  return useQuery<ProjectDto>({
    queryKey: projectsKeys.detail(id ?? ""),
    queryFn: () => getProject(id!),
    enabled: Boolean(id),
    meta: apiErrorMeta.projectDetail,
  });
}
